import type { StageStatus } from "@/adapters/api";
import type { BadgeVariant } from "@/components/ui/badge.tsx";

interface StageStatusPresentation {
	label: string;
	variant: BadgeVariant;
}

export const STAGE_STATUS: Record<StageStatus, StageStatusPresentation> = {
	pending: {
		label: "Pendente",
		variant: "secondary",
	},
	in_progress: {
		label: "Em andamento",
		variant: "info",
	},
	completed: {
		label: "Concluída",
		variant: "success",
	},
	cancelled: {
		label: "Cancelada",
		variant: "outline",
	},
};

export const STAGE_STATUSES = Object.keys(STAGE_STATUS) as StageStatus[];
